
  export default {
    name: 'NavigationBar',
    methods: {
      addToOutlook() {
        window.open("https://appsource.microsoft.com/en-us/product/office/WA200005112?tab=Overview")
      }
    }
  }
  